const Theme = {
  primaryDark: '#6b40ad',
  primaryLight: '#46d5da',
  primaryHover: '#1b1035',
  mobile: '320px'
};

export default Theme;
